module.exports = __webpack_public_path__ + "img/FRIDGE_AMENITY.435a5de2.svg";